<template>
  <div class="wrapper">
    <div class="searchBar">
      <h3>数据筛选</h3>
      <el-form
        ref="form"
        size="small"
        :inline="true"
        :model="searchCondition"
        label-width="100px"
      >
        <el-form-item label="输入查询：">
          <el-input
            v-model="searchCondition.search"
            placeholder="姓名/账号/手机/邮箱"
          ></el-input>
        </el-form-item>

        <el-form-item label="审核状态">
          <el-select v-model="searchCondition.photoStatus">
            <el-option label="所有" :value="-1"></el-option>
            <el-option label="通过" :value="1"></el-option>
            <el-option label="失败" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="getData()">查询</el-button>
      <el-button
        size="small"
        @click="Object.assign(searchConditon, $options.data().searchConditon)"
        >重置</el-button
      >

      <el-button
        type="primary"
        size="small"
        @click="download('../照片采集导入模板.xlsx')"
      >
        下载模板</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="
          Object.assign(importData, $options.data().importData);
          importData.ifShow = true;
        "
      >
        导入</el-button
      >
    </div>
    <div class="contentContainer">
      <el-table :data="dataList" border style="width: 100%">
        <el-table-column prop="userName" label="姓名" width="80">
        </el-table-column>
        <el-table-column prop="sex" label="性别" width="40"> </el-table-column>
        <el-table-column prop="groupId" label="所属分类"> </el-table-column>
        <el-table-column prop="cjCode" label="采集码" width="200">
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="200">
        </el-table-column>
        <el-table-column prop="idCard" label="身份证" width="200">
        </el-table-column>
        <el-table-column prop="institutionType" label="院校类别">
        </el-table-column>
        <el-table-column prop="educationalLevel" label="学历层次">
        </el-table-column>
        <el-table-column prop="schoolName" label="学校名称"> </el-table-column>
        <el-table-column prop="schoolNo" label="学号"> </el-table-column>
        <el-table-column prop="profession" label="专业"> </el-table-column>
        <el-table-column prop="photoStatusText" label="审核状态"></el-table-column>
        <el-table-column prop="reviewRemark" label="审核意见"></el-table-column>
        <el-table-column prop="updateTime" label="审核时间"> </el-table-column>
        <el-table-column prop="auditer" label="审核人"> </el-table-column>
        <el-table-column prop="createTime" label="上传时间"></el-table-column>
      </el-table>
      <el-pagination
        small
        layout="prev, pager, next"
        :current-page.sync="searchCondition.pageNumber"
        :page-size.sync="searchCondition.pageSize"
        :total="searchCondition.total"
        @current-change="getData()"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="批量导入"
      :visible.sync="importData.ifShow"
      width="960px"
      :append-to-body="true"
    >
      <el-steps :active="importData.step">
        <el-step title="上传文件"></el-step>
        <el-step title="执行导入"></el-step>
        <el-step title="导入完成"></el-step>
      </el-steps>
      <div class="importStep" v-show="importData.step == 0">
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">填写导入学生的信息</div>
            <div class="detail">
              请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除
            </div>
            <div>
              <el-button
                type="text"
                size="mini"
                @click="download('../照片采集导入模板.xlsx')"
                >下载模板</el-button
              >
            </div>
          </div>
        </div>
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">上传填好的学生信息表</div>
            <div class="detail">
              文件后缀名必须为xls 或xlsx （即Excel格式），文件大小不得大于10M
            </div>
            <div>
              <el-upload
                :on-change="uploadChange"
                action="/base/common/importPhotoUser"
                :data="importData"
                :file-list="importData.fileList"
                :on-success="importSuccess"
                :headers="{ Authorization: getStore('accessToken') }"
                :on-remove="
                  () => {
                    importData.fileList = [];
                  }
                "
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              >
                <el-button type="text" size="mini">上传文件</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <div class="importStep" v-show="importData.step == 1">
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">本次可导入数量</div>
            <div>
              <el-button type="text">{{ importData.successNum }}人</el-button>
            </div>
          </div>
        </div>
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">本次不可导入数量</div>
            <div>
              <el-button type="text">{{ importData.failNum }}人</el-button>
            </div>
          </div>
        </div>
        <h3 v-if="importData.failNum > 0">不可导入列表</h3>
        <el-table
          v-if="importData.failNum > 0"
          :data="importData.failList"
          border
          style="width: calc(100% - 40px); margin: 20px"
        >
          <el-table-column prop="userName" label="姓名" width="80">
          </el-table-column>
          <el-table-column prop="sex" label="性别" width="40">
          </el-table-column>
          <el-table-column prop="groupId" label="所属分类"> </el-table-column>
          <el-table-column prop="mobile" label="手机号" width="200">
          </el-table-column>
          <el-table-column prop="idCard" label="身份证" width="200">
          </el-table-column>
          <el-table-column prop="institutionType" label="院校类别">
          </el-table-column>
          <el-table-column prop="educationalLevel" label="学历层次">
          </el-table-column>
          <el-table-column prop="schoolName" label="学校名称">
          </el-table-column>
          <el-table-column prop="schoolNo" label="学号"> </el-table-column>
          <el-table-column prop="profession" label="专业"> </el-table-column>
          <el-table-column prop="photoStatusText" label="审核状态">
          </el-table-column>
        </el-table>
      </div>
      <div class="importStep" v-show="importData.step == 2">
        <h1 style="text-align: center">批量导入完成</h1>
        <h3 style="text-align: center">
          成功导入教师数量:{{ importData.successNum }}人
        </h3>
      </div>
      <div slot="footer">
        <el-button
          type="primary"
          @click="importData.step++"
          v-if="importData.step == 0"
          :disabled="!importData.fileList[0]"
          >下一步</el-button
        >
        <el-button
          type="primary"
          @click="doImportStudentIntoCourse"
          v-if="importData.step == 1"
          >提交并执行</el-button
        >
        <el-button
          type="primary"
          @click="importData.step = 0"
          v-if="importData.step == 1"
          plain
          >返回重新上传</el-button
        >
        <el-button
          type="primary"
          @click="importData.ifShow = false"
          v-if="importData.step == 2"
          >完成</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  photoImportList,
  photoReview,
  importPhotoUser,
} from "@/api/examination.js";
export default {
  data() {
    return {
      searchCondition: {
          pageNumber: 1,
        pageSize: 10,
        search: "",
        photoStatus: -1,
        total: 0,
      },
      importData: {
        ifShow: false,
        isExecute: 0,
        importFile: null,
        fileList: [],
        failList: [],
        step: 0,
        failNum: 0,
        successNum: 0,
      },
      dataList: [],
    };
  },
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      photoImportList(this.searchCondition).then((data) => {
        console.log(data);
        this.dataList = data.data.rows;
        this.searchCondition.total = data.data.total;
      });
    },
    audit(status, item) {
      this.$confirm(`确认删除吗`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then((data) => {
        photoReview({ batchPhotoStatus: status, ids: [item.id] }).then(
          (data) => {
            this.$message.success("操作成功");
            console.log(data);
            this.getData();
          }
        );
      });
    },

    doImportStudentIntoCourse() {
      let postData = new FormData();
      postData.append("file", this.importData.fileList[0]);
      postData.append("isExecute", 1);

      importPhotoUser(postData).then((data) => {
        this.importData.step = 2;
        this.getData();
      });
    },
    uploadChange(e) {
      if (e.percentage == 100) {
        this.importData.fileList = [e.raw];
      }
    },
    importSuccess(response, file, fileList) {
      this.importData.importFile = file;
      Object.assign(this.importData, response.data);
    },
    download(url) {
      location.href = url;
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .searchBar {
    background: #fff;
    margin: 20px;
    padding: 20px;
  }
  .contentContainer {
    background: #fff;
    margin: 20px;
    padding: 20px;
  }
}
.importStep {
  padding: 40px 0;
  .importBar {
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    margin: 20px 0;
    .iconSide {
      width: 200px;
    }
    .detailSide {
      flex: 1;
      padding: 10px 0;
      .title {
        font-size: 24px;
        line-height: 42px;
      }
      .detail {
        color: #999;
        line-height: 36px;
      }
    }
  }
}
</style>
